<template>
    <div class="flex flex-wrap mt-4">
        <table class="min-w-full border border-theme-border text-theme-base">
            <thead class="text-md py-4">
                <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Slug</th>
                    <th v-if="showRole" scope="col">Rol otorgante</th>
                </tr>
            </thead>
            <tbody class="text-sm">
                <tr
                    v-for="(item, index) in items"
                    :key="index"
                    class="border-t border-theme-border py-2"
                >
                    <td class="w-1/4 px-2">
                        <span>
                            {{ item.slug }}
                        </span>
                    </td>
                    <td class="w-5/12">
                        <span>
                            {{ item.name }}
                        </span>
                    </td>
                    <td class="w-4/12">
                        <span>
                            {{ item.role }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "PermissionsTable",
    props: {
        items: {
            type: Array,
            default: () => [
                {
                    name: "Get Own User",
                    slug: "get:UserOwn",
                    role: "Super"
                }
            ],
            required: true
        },
        showRole: {
            type: Boolean,
            default: () => false,
            required: true
        }
    },
    computed: {
        ...mapGetters("control", ["tableDark"])
    }
};
</script>
